import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
  showLabel?: boolean;
}
export function CountdownTimer({
  className = '',
  showLabel = false
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(643); // 10:43 in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className={`font-bold ${className}`} data-id="element-27">
      {showLabel && <span className="mr-2" data-id="element-28">Tiempo restante:</span>}
      <span className="tabular-nums" data-id="element-29">
        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
      </span>
    </div>;
}